import axios from "axios"
import { ErrorLogService } from "@/services/ErrorLogService"

export const ManualsService = Object.freeze({
  GetUrl: function (brandAuth) {
    var reqUrl = window.appGlobals.API_URL + "Manuals/GetUrl?brandAuth=" + brandAuth

    return axios.get(reqUrl).catch(err => {
      ErrorLogService.LogException(err)

      return new Promise(function (resolve, reject) {
        resolve(false)
      })
    })
  }
})
